import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.module.scss';
import { Row, Col } from 'react-bootstrap';
import _ from 'lodash';
import MsDynamicsConfigurationPage from './MsDynamicsConfigurationPage';
import DeactivateIntegrationContainer from 'src/legacy/components/DeactivateIntegration/index'
import { MsDynamicsSideBar } from './MsDynamicsSideBar';
import { MsDynamicsOnboardingView } from './MsDynamicsOnboardingView';
import PlaceholderEmptyMessage from "src/legacy/components/PlaceholderEmptyMessage";
import DeactivatedMsDynamics from 'src/legacy/images/deactivated_salesforce.svg';
import MsDynamicsInstanceView from './MsDynamicsInstanceView';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import { shouldFetchIntegrations } from 'src/legacy/services/utils';
import { localizedStrings } from 'src/localization/index.jsx';

import buildUrl from "build-url-ts";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

class MsDynamics extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      deleteConfirmation: false,
      isScrollDisabled: false,
      selectedTab: null,
      integration: this.props.integration,
      integrationCreatedBy: _.get(this.props.integration, "createdBy") || '',
      isAuthenticated: false,
      showIntergrationOnboarding: false,
      showInstanceUrlPage: false,
      instanceUrl: "",
      showErrorMessage: null

    };

    this.handleAuthenticate = this.handleAuthenticate.bind(this);
    this.handleAuthenticateEvent = this.handleAuthenticateEvent.bind(this);
    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);
    this.handleOnboardingComplete = this.handleOnboardingComplete.bind(this);
    this.handleOverrideAuthenticate = this.handleOverrideAuthenticate.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedMsDynamics = localizedStrings.components.integrations.ms_dynamics;


    this.showIntergrationOnboarding = this.showIntergrationOnboarding.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.disableScroll = this.disableScroll.bind(this);
    this.canEdit = this.canEdit.bind(this);
  }

  componentDidMount() {

    if(shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }
    
    this.props.fetchMsDynamicsIntegration();

    const integration = localizedStrings.constants.integrationsOnboarding.integrations.ms_dynamics;
    const sections = integration.sections;
    this.setState({
      selectedTab: sections[0].id
    })
    if (_.get(this.props, 'integration.state.code') === 'ok' && !_.get(this.props, 'error')) {

      this.setState({ 
        isAuthenticated: true,
        showErrorMessage: false
      });
    } else if((_.get(this.props, 'integration.state.code') === 'auth_error')) {
      this.setState({
        showErrorMessage: true,
      })
    }
  }

  componentWillReceiveProps(nextProps){
    if((_.get(this.props, 'errors')) != _.get(nextProps, 'errors')){
      this.setState({
        errors: _.get(nextProps,"errors[0]")
      })
    } 
    if (_.get(nextProps, 'integration.state.code') === 'ok' && !_.get(nextProps, 'error')) {
      this.setState({ 
        isAuthenticated: true,
        showInstanceUrlPage: false,
        showErrorMessage: false

      });
    }else if((_.get(this.props, 'integration.state.code') === 'auth_error')) {
        this.setState({
          showErrorMessage: true,
        })
    }
  }

  _handleDeactivateClicked(){
      this.setState({
        deleteConfirmation: true
      })

  }

  canEdit() {
    if (_.get(this.props, "user.admin")) {
      return true;
    } else if (_.get(this.state, "integrationCreatedBy")) {
      return (_.get(this.state, "integrationCreatedBy.id") === (_.get(this.props, "user.id")));
    }
    return false;
  }

  showIntergrationOnboarding() {
      this.setState({
        showIntergrationOnboarding: !this.state.showIntergrationOnboarding,
      }, () => {
        if(this.state.showIntergrationOnboarding) {
          this.setState({
            showErrorMessage: false,
          });
        } 
        else {
          this.setState({
            showErrorMessage: !this.state.isAuthenticated
          });
        }
      });
    }

  disableScroll(value){
    this.setState({
      isScrollDisabled: value
    })
  }
  handleScroll(e){
    if(this.state.isScrollDisabled){
      return;
    }

    const integration = localizedStrings.constants.integrationsOnboarding.integrations.ms_dynamics;
    const sections = integration.sections;

    if(sections) { 
     
    for (let i = 0; i < sections.length; i++) {
      const offsets = document.getElementById(`${sections[i].id}`)?.getBoundingClientRect();
      const position = offsets?.top;
      
      if(offsets) {
        if (e.target.scrollTop >= position) {
          this.setState({
            selectedTab: sections[i].id
          })
        }
      }
  }
}
  }

  handleOverrideAuthenticate() {
    this.setState({
      instanceUrl: _.get(this.props.integration, "configuration.instance")
    }, () => {
      this.handleAuthenticate(this.state.instanceUrl, 'secondary');
    })
  }

  render() {

    if (this.props.loading) {
      return this._renderLoadingMessage();
    }

    var isTokenExpired = _.get(this.props, 'integration.state.code') === "auth_error";

    return (
      <div className={styles.content}>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            <MsDynamicsSideBar
              integration={this.props.integration}
              showIntergrationOnboarding={this.showIntergrationOnboarding}
              _handleDeactivateClicked={this._handleDeactivateClicked}
              handleOnboardingComplete={this.handleOnboardingComplete}
              canEdit={this.canEdit}
              deactivating={this.props.deactivating}
              isAuthenticated={this.state.isAuthenticated}
              authenticating={this.props.authenticating}
              isTokenExpired={isTokenExpired}
              navigate={this.props.navigate}
              isShowIntergrationOnboarding={this.state.showIntergrationOnboarding}
            />
          </Col>       
          <Col
          md={9} id="right" className={styles.right} onScroll={(e) => this.handleScroll(e)}>
              {this.state.showErrorMessage && (
              <div className={styles.errorContainer}>
                <PlaceholderEmptyMessage
                  title={this.localizedMsDynamics.error_messages.token_expired.title}
                  message={this.canEdit() ? this.localizedMsDynamics.error_messages.token_expired.sub_text: this.localizedMsDynamics.error_messages.token_expired.non_admin}
                  image={DeactivatedMsDynamics}
                  className={styles.emptyMessage}
                  visible={true}
                />
              </div>
            )}

            {this.props.integrationsLoading && (
              <p className={styles.integrationLoading}>
                {this.localizedCommons.loading.loading}...
              </p>
            )}
            {(this.state.showIntergrationOnboarding || (!this.state.showInstanceUrlPage && (_.isEmpty(this.props.integration)))) && (
                <MsDynamicsOnboardingView
                  selectedTab={this.state.selectedTab}
                  disableScroll={this.disableScroll}
                />
              )}
                { !this.state.showIntergrationOnboarding &&  !this.state.isAuthenticated && this.state.showInstanceUrlPage &&  (
                   <MsDynamicsInstanceView authenticating= {this.props.authenticating} handleAuthenticate={(url) => this.handleAuthenticate(url, 'primary')}/>
             )}

            {!this.state.showInstanceUrlPage && this.state.isAuthenticated && !this.state.showIntergrationOnboarding && (
              <MsDynamicsConfigurationPage store={this.context.store} integration= {this.props.integration} OverrideConfig = {this.handleOverrideAuthenticate.bind(this)}/>
            )}
          </Col>
        </Row>
        <DeactivateIntegrationContainer
          name={this.localizedMsDynamics.deactivate_slider.title}
          type="ms-dynamics"
          message={localizedStrings.formatString(this.localizedMsDynamics.deactivate_slider.sub_text)}
          show={this.state.deleteConfirmation}
          onCancel={() => {
            this.setState({
              deleteConfirmation: false,
            });
          }}
        />
      </div>
    );
  }
  _renderLoadingMessage() {
    return (
      <LoadingMessage
        className={styles.loadingMessage}
        message={`${this.localizedMsDynamics.loading.config}...`}
        visible={this.props.loading}
      />
    )
  }
  handleOnboardingComplete() {
    this.setState({ 
      showIntergrationOnboarding: false, 
      showInstanceUrlPage: true, 
      isAuthenticated: false,
      showErrorMessage: false
    });
  }
  handleAuthenticate(instanceUrl, overrideInstance) {
    //Calculate Position
    //eslint-disable-next-line
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    //eslint-disable-next-line
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
    //eslint-disable-next-line
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    //eslint-disable-next-line
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var w = 0.8 * width;
    var h = 0.8 * height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;

    const url = buildUrl(apiUrl, {
      path: `/api/2.0/integrations/ms-dynamics/authorize`
    })
    
    var newWindow = window.open(url, `Authorize microsoft dynamics Account`, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (newWindow && newWindow.focus) {
      newWindow.focus();
    }

    //Attaching message event listner
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, (e) => this.handleAuthenticateEvent(e,instanceUrl, overrideInstance), false);
    return false;
  }

  handleAuthenticateEvent(e,instanceUrl, overrideInstance) {

    //Removing message event listner
    var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
    var deEventer = window[detachEventMethod];
    var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";

    if (e.data.type == 'MS_DYNAMICS_AUTHORIZATION_SUCCESS') {
      var code = e.data.payload.code;
      var state = e.data.payload.state;
      var location = e.data.payload.location;
      var error = e.data.payload.error;
      this.props.trackAdoptionMetricsForPluginConnectedEvent('Microsoft Dynamics');
      if (!error) {
        if (overrideInstance === 'primary') {
          this.props.authenticateAccount(code, instanceUrl);
        } else if (this.props.integration && overrideInstance === 'secondary') {
          let primaryIntegrationId = _.get(this.props, 'integration.id');
          this.props.authenticateSecondaryAccount(primaryIntegrationId, code, instanceUrl);
        }
      }

      deEventer(messageEvent, (e) => this.handleAuthenticateEvent(e, instanceUrl, overrideInstance), false);
    }
  }

}

export default MsDynamics;